import(/* webpackMode: "eager" */ "/vercel/path0/src/app/DMCA/page.tsx");
